<template>
  <div class="container-flight margin_container_hf">
    <flight-search class="search-box" />
    <PDKModal
      :buttonObject="modalButtonProps"
      v-if="showTimerModal"
      @btnAction="onTimeoutModalAction"
    >
      <div style="text-align: center" slot="body">
        <img
          id="timer-logo"
          width="150"
          height="150"
          src="../../../public/img/out-of-ti.png"
        />
        <h4 style="margin-top: 10px">زمان شما برای تایید رزرو به اتمام رسید</h4>
      </div>
    </PDKModal>

    <Summary
      v-if="tripType == 2"
      :selectedDeparture="selectedDeparture"
      :selectedReturn="selectedReturn"
    />
    <Summary v-if="tripType == 1" :selectedDeparture="selectedDeparture" />

    <div>
      <h3>
        <i class="icon-users-1"></i>اطلاعات مسافرین
      </h3>
    </div>
    <div class="cart-section">
      <table class="table table-striped cart-list shopping-cart">
        <thead>
          <tr>
            <th>نام و نام خانوادگی</th>
            <th>نام و نام خانوادگی لاتین</th>
            <th>جنسیت</th>
            <th>تاریخ تولد</th>
            <th>ملیت</th>
            <th>کدملی / شماره پاسپورت</th>
            <th>
              <button class="btn btn-primary" @click="editPassengerInfo">
                ویرایش
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(passenger, index) in bookingDetail.passengers"
            :key="index"
          >
            <td>
              <strong
                >{{ passenger.persianName }}&nbsp;{{
                  passenger.persianFamily
                }}</strong
              >
            </td>
            <td>
              <strong
                >{{ passenger.englishName }}&nbsp;{{
                  passenger.englishFamily
                }}</strong
              >
            </td>
            <td v-if="passenger.genderId === 1">مرد</td>
            <td v-else>زن</td>
            <td>
              <strong>{{ passenger.birthDate }}</strong>
            </td>
            <td class="options">
              <strong v-if="passenger.nationalityId === 1">ایرانی</strong>
              <strong v-else>غیر ایرانی</strong>
            </td>
            <td class="options">
              <strong>{{ passenger.nationalCode }}</strong>
            </td>
            <td class="options">
              <strong></strong>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="cart-options clearfix">
        <div class="float-left"></div>
      </div>
      <br />
      <div class="row justify-content-end">
        <div class="column col-lg-5 col-md-6">
          <div style="line-height: 2; margin-bottom: 30px" class="totals-table">
            <div class="clearfix total">
              <span class="col">مبلغ قابل پرداخت :</span
              ><span style="font-weight: bold" class="col"
                >{{ totlaPrice | numFormat | rial }}
              </span>
            </div>
          </div>
          <div class="role-text">
            <input
              :disabled="isDisableRoleCheck"
              v-model="ruleChecked"
              type="checkbox"
            />
            &ensp;
            <label
              ><a
                href="#role-dialog"
                id="role_link"
                style="cursor: pointer !important"
                class="role"
                ><span style="cursor: pointer !important">قوانین و مقررات</span>
              </a>
              را می پذیرم.</label
            >
          </div>
          <div class="radios">
            <div class="radio">
              <input
                type="radio"
                id="bank"
                value="false"
                v-model="isCredit"
                checked
              />
              <label for="bank">
                <div class="checker"></div>
                <img
                  width="20px"
                  height="20px"
                  style="margin-left: 4px"
                  src="../../../public/img/mellat.png"
                  alt=""
                />
                پرداخت آنلاین
              </label>
            </div>

            <div class="radio">
              <input
                :disabled="isDisableCreditChecked"
                type="radio"
                id="credit"
                value="true"
                v-model="isCredit"
                name="radio"
              />
              <label for="credit">
                <div class="checker"></div>
                <span>
                  پرداخت از اعتبار
                  <span style="color: #08446a; font-weight: bold"
                    >( <span>{{ deposit | numFormat }}</span> ریال)</span
                  >
                </span>
              </label>
            </div>
          </div>

          <div v-if="isDisableTimer">
            <button
              style="width: 100%; width: 75%; margin-right: 14%"
              disabled
              class="btn btn-primary"
            >
              <span v-show="!isLoading"
                >پرداخت و رزرو <i class="icon-left"></i
              ></span>
              <span v-show="isLoading"
                >در حال انجام ... <i class="fa fa-spinner fa-pulse"></i
              ></span>
            </button>
          </div>
          <div v-else>
            <button
              style="width: 100%; width: 75%; margin-right: 14%"
              @click="book"
              :disabled="isDisableButton"
              class="btn btn-primary"
            >
              <span v-show="!isLoading"
                >پرداخت و رزرو <i class="icon-left"></i
              ></span>
              <span v-show="isLoading"
                >در حال انجام ... <i class="fa fa-spinner fa-pulse"></i
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <flight-rule />
  </div>
</template>


<script>
import Store from "../../views/flight/store/index";
import PDKModal from "@/components/PDKAlertModal";
import FlightSearch from "./FlightSearch.vue";
import Summary from "./FlightSummery";
import FlightRule from "./FlightRuleModal.vue";
import moment from "moment-jalaali";
import $ from "jquery";

export default {
  store: Store,
  components: { FlightSearch, Summary, PDKModal, FlightRule },
  data() {
    return {
      isDisableTimer: false,
      hotelList: [],
      cityList: [],
      isDisableCreditChecked: false,
      deposit: 0,
      reserveNo: "",
      isCredit: false,
      isDisableButton: false,
      isDisableRoleCheck: false,
      isLoading: false,
      ruleChecked: false,
      totalNight: 0,
      passengers: [],
      passengerForm: [],
      modalButtonProps: {
        title: "جستجوی مجدد",
      },
      showTimerModal: false,

      searchItems: {},
      params: {},

      bookingDetail: {},
      tripType: 1,
      totlaPrice: 0,
    };
  },
  watch: {
    ruleChecked: function (val) {
      if (val === true && this.totlaPrice > 0) {
        this.isDisableButton = false;
      } else {
        this.isDisableButton = true;
      }
    },
    isLoading: function (val) {
      if (val === true) {
        this.isDisableButton = true;
        this.isDisableRoleCheck = true;
      } else {
        this.isDisableRoleCheck = false;
        this.isDisableButton = false;
      }
    },
  },
  created() {
    this.params = this.$route.query;

    this.tripType = parseInt(this.params.tripType);

    const getTwoWayFlightSelected = this.$store.getters.GetTwoWayFlightSelected;
    const getOneWayFlightSelected = this.$store.getters.GetOneWayFlightSelected;

    if (getOneWayFlightSelected != "") {
      this.selectedDeparture = getOneWayFlightSelected;
    }

    if (getTwoWayFlightSelected != "") {
      this.selectedDeparture = getTwoWayFlightSelected.selectedDeparture;
      this.selectedReturn = getTwoWayFlightSelected.selectedReturn;
    }
    if (Object.keys(this.$store.getters.GetPassengerDetail).length) {
      this.bookingDetail = this.$store.getters.GetPassengerDetail;
    } else {
      this.onTimeoutModalAction();
    }

    if (this.ruleChecked === false) {
      this.isDisableButton = true;
    }

    this.tripType = parseInt(this.params.tripType);
    this.calcTotlaPrice();

    this.getCredit();
  },

  methods: {
    async getCredit() {
      var deposit = localStorage.getItem("SelectedSourceDeposit");
      this.deposit = deposit;

      if (deposit < this.packageTotalPrice) {
        this.isDisableCreditChecked = true;
      }
    },

    calcTotlaPrice() {
      if (this.tripType == 2) {
        this.totlaPrice =
          parseInt(this.selectedDeparture.totalAdultFare) +
          parseInt(this.selectedReturn.totalAdultFare);
      } else if (this.tripType == 1) {
        this.totlaPrice = parseInt(this.selectedDeparture.totalAdultFare);
      }
    },

    editPassengerInfo() {
      this.$router.push({
        path: "flightbook",
        name: "flightbook",
        query: {
          originName: this.params.originName,
          destinationName: this.params.destinationName,
          origin: this.params.origin,
          destination: this.params.destination,
          fromDate: this.params.fromDate,
          toDate: this.params.toDate,
          adultQty: this.params.adultQty,
          infantQty: this.params.infantQty,
          childQty: this.params.childQty,
          tripType: this.params.tripType,
        },
      });
    },
    async book() {
      this.params = this.$route.query;
      this.tripType = parseInt(this.params.tripType);

      let reserveItineraries;
      if (this.tripType === 1) {
        reserveItineraries = [this.selectedDeparture];
      } else {
        reserveItineraries[(this.selectedDeparture, this.selectedReturn)];
      }
      const passengers = [];
      this.bookingDetail.passengers.forEach((element) => {
        const convertPass = {
          ageType: element.ageType,
          mobilePhone: element.mobilePhone,
          email: element.email,
          persianFirstName: element.persianName,
          persianFamilyName: element.persianFamily,
          firstName: element.englishName,
          familyName: element.englishFamily,
          genderId: element.genderId,
          nationalityId: element.nationalityId,
          documentId: element.nationalCode,
          birthDate: moment(element.bthd, "jYYYY/jMM/jDD").format("YYYY/MM/DD"),
        };

        passengers.push(convertPass);
      });
      const numberOfTicket =
        parseInt(this.params.adultQty) +
        parseInt(this.params.childQty) +
        parseInt(this.params.infantQty);
      let data = {
        reserveModels: [
          {
            providerName: "zv",
            currencyId: 0,
            totalFare: this.totlaPrice,
            isRoundTrip: false,
            numberOfAdult: this.params.adultQty,
            numberOfChild: this.params.childQty,
            numberOfInfant: this.params.infantQty,

            numberOfTicket: numberOfTicket,
            description: "",
            customerRequest: "",
            passengers: this.bookingDetail.passengers,
            reserveItineraries: reserveItineraries,
          },
        ],
        sourceId: localStorage.getItem("SourceIdInReport"),
      };

      const reserve = await this.$store.dispatch("reserveFlight", data);
      console.log(reserve);

      if (!this.isCredit) {
        this.isLoading = false;
      } else {
      }
    },
    onTimeoutModalAction() {
      this.$router
        .push({
          name: "flightSearch",
          query: {
            origin: this.params.origin,
            destination: this.params.destination,
            originName: this.params.originName,
            destinationName: this.params.destinationName,
            fromDate: this.params.fromDate,
            toDate: this.params.toDate,
            adultQty: this.params.adultQty,
            infantQty: this.params.infantQty,
            childQty: this.params.childQty,
            tripType: this.params.tripType,
          },
        })
        .catch(() => {});
    },
    endTimeCountdown() {
      this.showTimerModal = true;
    },
  },
  mounted() {
    require("magnific-popup");
    $(this.$el.querySelector("#role_link")).magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });
  },
};
</script>
<style lang="scss" scoped>
.role {
  color: #0a6c9f !important;
  font-weight: bold;
  cursor: pointer !important;
}
.custom_form_title h3 strong {
  margin-top: -4px !important;
  margin-right: 3px !important;
  height: 35px !important;
  width: 35px !important;
  background-color: #bdc6cb !important;
}
.custom_form_title {
  margin-bottom: 0px !important;
  padding-right: 45px !important;
}

.custom_row {
  margin-top: 50px;
}
.styled-select {
  background-color: white !important;
  border: 1px solid #ced4da !important;
}
.role-text {
  margin-bottom: 20px;
}
.radios {
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 640px) {
    flex-direction: column;
  }
}

.radio {
  input {
    position: absolute;
    pointer-events: none;
    visibility: hidden;
  }

  input:focus + label {
    background: #eeeeff;

    .checker {
      border-color: #6666ff;
    }
  }

  input:checked + label {
    .checker {
      box-shadow: inset 0 0 0 6px #6666ff;
      margin-left: 4px;
    }
  }

  label {
    display: flex;
    align-items: center;
    height: 28px;
    border-radius: 14px;
    margin: 10px;
    padding: 0 8px 0 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background: #eeeeff;

      .checker {
        box-shadow: inset 0 0 0 2px #6666ff;
      }
    }
  }

  .checker {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 8px;
    box-shadow: inset 0 0 0 2px #ccc;
    transition: box-shadow 0.3s ease;
    margin-left: 4px;
  }

  .room-box {
    min-height: 320px !important;
    padding: 20px;
    position: relative;
    background: #fff;
    margin-bottom: 30px;
    color: #888;
    -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  }
}

.customer_request {
  margin-top: 50px;
  text-align: initial;
  font-size: 14px;
  padding: 15px 5px 15px 5px;
  background: #fbfdff;
}
.search-box {
  position: relative;
  z-index: 9999;
  padding-bottom: 40px;
}
</style>